import React from "react";
import { useLocation } from "react-router-dom";
import { DeactivatedIcon } from "../../../assets/icons";
import { AccountDeleted } from "../../../assets/icons";
import "../style.scss";
import { useTranslation } from "../../../i18n/LanguageContext";

const AccountDeletedORDeactivated = () => {
   const { t } = useTranslation();
   const location = useLocation();
   const params = new URLSearchParams(location.search);
   const action = params.get("action");

   return (
      <div className="pt-md-15 pr-md-10 pb-md-15 pl-md-10 custom-div accountDeletedDeactivated">
         <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
            <div className="d-flex justify-content-center">
               <img
                  src={action === "deactivate" ? DeactivatedIcon : AccountDeleted}
                  alt={t("account-action-icon-alt")}
               />
            </div>
            <div className="d-flex flex-column align-items-center">
               <label className="labelStatus">
                  {action === "deactivate"
                     ? t("account-deactivated-notice-text")
                     : t("account-deleted-notice-text")}
               </label>
               <div className="d-flex flex-column align-items-center lastParagraphSection">
                  <p className="paragraph-text">{t("positive-experience-farewell-text")}</p>
                  <p className="last-paragraph-text">{t("kaporg-best-regards-text")}</p>
               </div>
            </div>
         </div>
      </div>
   );
};

export default AccountDeletedORDeactivated;
